export const lockerKey = 'PENDING_FILES';
